export default __webpack_public_path__ + "static/banner3-4eccc5bc38f0633f53d4bbb07859f992.png";